import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useFetchProfile = (token) => {
  const { role } = useContext(AuthContext);

  const fetchProfile = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    const userType = localStorage.getItem("userType");

    if (!userType) {
      throw new Error("User type is missing in local storage");
    }

    let endpoint;
    switch (userType) {
      case "Charterer":
        endpoint = `${process.env.REACT_APP_SERVER_URL}/charterer/profile/me`;
        break;
      case "Vessel Owner":
        endpoint = `${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/me`;
        break;
      default:
        throw new Error("Invalid user type");
    }

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const responseData = await response.json();

    if (!response.ok) {
      throw new Error(responseData.message || "Failed to fetch profile");
    }

    // Ensure the role is included in the profile data
    return { ...responseData.data, role };
  };

  const {
    data: profileData,
    error: profileError,
    isLoading: profileLoading,
  } = useQuery(["profile", token], fetchProfile, {
    enabled: !!token 
  });

  return {
    profileData,
    profileError,
    profileLoading,
  };
};

export default useFetchProfile;

